var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73582 7.53987L9.12048 3.15521C9.22395 3.05174 9.34467 3 9.48264 3C9.6206 3 9.74132 3.05174 9.84479 3.15521C9.94826 3.25868 10 3.38156 10 3.52383C10 3.66611 9.94826 3.78898 9.84479 3.89245L5.09798 8.6522C4.9945 8.75567 4.87378 8.80741 4.73582 8.80741C4.59786 8.80741 4.47714 8.75567 4.37367 8.6522L2.149 6.42754C2.04553 6.32406 1.99595 6.20119 2.00026 6.05891C2.00457 5.91664 2.05846 5.79377 2.16193 5.69029C2.26541 5.58682 2.38828 5.53508 2.53056 5.53508C2.67283 5.53508 2.79571 5.58682 2.89918 5.69029L4.73582 7.53987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckS);
export default __webpack_public_path__ + "static/media/check-s.dee181424eb68bda11b2a21f9195b388.svg";
export { ForwardRef as ReactComponent };